import { Song, SocialLink } from '../types';

export const highlightSongs: Song[] = [
  {
    id: '1',
    title: 'Giải mã (aka Decoded) - Rap - atomix',
    description: 'Energetic AI rap remix fusing cyber rhythmic cadence with hard-hitting electronic synthesis.',
    coverImage: 'https://i.ytimg.com/vi/WOy6G8MgSos/hqdefault.jpg',
    youtubeUrl: 'https://www.youtube.com/watch?v=WOy6G8MgSos&list=PL6cyrmMYIMyze5hZ_PKSCvFHezdykGR1m&index=1',
    spotifyUrl: 'https://open.spotify.com/artist/atomixmusic',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-12-15',
    tags: ['Rap', 'Remix', 'Cyber Beat'],
    style: 'Fast-paced AI Rap & Trap Fusion'
  },
  {
    id: '2',
    title: 'Mong manh - Indie Pop - atomix',
    description: 'Ethereal indie pop soundscape blending delicate vocal synthesis and melancholic acoustic tones.',
    coverImage: 'https://i.ytimg.com/vi/oOxiwK_DhUU/hqdefault.jpg',
    youtubeUrl: 'https://www.youtube.com/watch?v=oOxiwK_DhUU&list=PL6cyrmMYIMyze5hZ_PKSCvFHezdykGR1m&index=2',
    spotifyUrl: 'https://open.spotify.com/artist/atomixmusic',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-12-15',
    tags: ['Indie Pop', 'Acoustic', 'Atmospheric'],
    style: 'Dreamy Generative Pop'
  },
  {
    id: '3',
    title: 'Ngày nhạt nắng - Pop Indie - atomix',
    description: 'Chill, introspective pop-indie vibe with warm chords, ambient pad textures, and smooth harmonies.',
    coverImage: 'https://i.ytimg.com/vi/MxmG4QLeb0w/hqdefault.jpg',
    youtubeUrl: 'https://www.youtube.com/watch?v=MxmG4QLeb0w&list=PL6cyrmMYIMyze5hZ_PKSCvFHezdykGR1m&index=3',
    spotifyUrl: 'https://open.spotify.com/artist/atomixmusic',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-12-15',
    tags: ['Pop', 'Indie', 'Chillout'],
    style: 'Lo-Fi Melodic Indie'
  },
  {
    id: '4',
    title: 'Ngày em xa (aka The day you went away) - Rap - atomix',
    description: 'Emotional narrative rap remix touching on memory and distance with dynamic drum sequencing.',
    coverImage: 'https://i.ytimg.com/vi/Mq5OmaV5k94/hqdefault.jpg',
    youtubeUrl: 'https://www.youtube.com/watch?v=Mq5OmaV5k94&list=PL6cyrmMYIMyze5hZ_PKSCvFHezdykGR1m&index=4',
    spotifyUrl: 'https://open.spotify.com/artist/atomixmusic',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-12-15',
    tags: ['Rap', 'Emotional', 'Ballad'],
    style: 'Melodic Rap'
  },
  {
    id: '5',
    title: 'Revenge Love (aka Trả thù Tình yêu) - Pop Rap - atomix',
    description: 'High-energy pop-rap crossover driven by punchy 808 bass lines and neon synth arpeggios.',
    coverImage: 'https://i.ytimg.com/vi/o4WF43pPTrg/hqdefault.jpg',
    youtubeUrl: 'https://www.youtube.com/watch?v=o4WF43pPTrg&list=PL6cyrmMYIMyze5hZ_PKSCvFHezdykGR1m&index=5',
    spotifyUrl: 'https://open.spotify.com/artist/atomixmusic',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-12-15',
    tags: ['Pop Rap', 'Synthwave', 'Dance'],
    style: 'Cyber Pop Rap'
  },
  {
    id: '6',
    title: 'Đường Song Song - Pop - atomix',
    description: 'Uplifting synth-pop anthem exploring dual paths and parallel destinies with rich vocal layering.',
    coverImage: 'https://i.ytimg.com/vi/J3XDjr1e_4M/hqdefault.jpg',
    youtubeUrl: 'https://www.youtube.com/watch?v=J3XDjr1e_4M&list=PL6cyrmMYIMyze5hZ_PKSCvFHezdykGR1m&index=6',
    spotifyUrl: 'https://open.spotify.com/artist/atomixmusic',
    tiktokUrl: 'https://tiktok.com/@atomixchannel',
    releaseDate: '2025-12-15',
    tags: ['Pop', 'Electronic', 'Vocals'],
    style: 'Modern Electro Pop'
  }
];

export const socialLinks: SocialLink[] = [
  {
    platform: 'youtube',
    name: 'YouTube',
    url: 'https://youtube.com/@atomixchannel',
    icon: 'youtube'
  },
  {
    platform: 'tiktok',
    name: 'TikTok',
    url: 'https://tiktok.com/@atomixchannel',
    icon: 'tiktok'
  },
  {
    platform: 'spotify',
    name: 'Spotify',
    url: 'https://open.spotify.com/artist/atomixmusic',
    icon: 'spotify'
  }
];
